export default __webpack_public_path__ + "static/media/Vitae_Game.39e2c34c.png";